import * as React from "react";
import {
    Box, IconButton, Switch, Chip
} from "@mui/material";

import  { Edit, MoreHoriz, Loop } from '@mui/icons-material';
import {getImage, getPrice} from "helpers/utils";
import "./SellerProduct.scss";
import BazaarButton from "components/BazaarButton";
import { FlexBetween, FlexBox } from "components/flex-box";
import {H2, H5, Tiny} from "components/CustomTypography";
import HoverBox from "components/HoverBox";
import LazyImage from "components/LazyImage";
import ArrowRight from "@mui/icons-material/ArrowRight";
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import {success} from "../../../../theme/themeColors";


const SellerProduct = (props) => {
  const {
    product = {}, editShopImages, editProductInfo, editProduct, symbol, currency, className = "",
    onToggleActive, onAccountBoxEdit,
  } = props;
  const { id, name, categories, images, price, is_popular, is_price_visible, is_price_onunlock, is_active, is_listing_active, store_entry, listing_id, has_model_image, has_pending_model_generation } = product;
  const galleryInput = images.map((image) => {
    const { id, cdn } = image;
    return {
      id,
      original: cdn.secure_url,
      thumbnail: cdn.secure_url,
    };
  });

  const handleToggleActive = (event) => {
    event.stopPropagation();
    const newActiveStatus = !is_listing_active;
    if (onToggleActive) {
      onToggleActive(listing_id, newActiveStatus);
    }
  };

  return (
      <Box 
          pb={2}
          sx={{
            border: '1px solid',
            borderColor: 'grey.300',
            borderRadius: '8px',
            padding: '12px',
            backgroundColor: 'background.paper',
            boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
            transition: 'box-shadow 0.2s',
            '&:hover': {
              boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
            }
          }}
      >
          <FlexBetween justifyContent='center' mb={1}>
              <Box width="20%">
              </Box>
              <Box width="60%">
                  {has_pending_model_generation && (
                      <Chip 
                          icon={<Loop />}
                          label="Processing"
                          size="small"
                          color="info"
                          sx={{
                              height: '24px',
                              fontSize: '11px',
                              fontWeight: 500,
                              animation: 'pulse 2s ease-in-out infinite',
                              '@keyframes pulse': {
                                  '0%, 100%': { opacity: 1 },
                                  '50%': { opacity: 0.7 }
                              }
                          }}
                      />
                  )}
              </Box>
              <Box width="20%">
                  <Switch
                      checked={is_listing_active || false}
                      onChange={handleToggleActive}
                      onClick={(e) => e.stopPropagation()}
                      size="small"
                      color="success"
                  />
              </Box>
          </FlexBetween>
          
          <HoverBox onClick={editProduct} m={0} mx="auto"
                    borderRadius="8px"
                    sx={{ position: 'relative', display: 'block' }}>
              <LazyImage
                  src={getImage(product.images)}
                  width="100%"
                  alt={product.name}
                  mx="auto"
                  style={{ borderRadius: '4px' }}
              />
              {onAccountBoxEdit && (
                  <IconButton
                      type="button"
                      size="small"
                      onClick={(e) => {
                        e.stopPropagation();
                        onAccountBoxEdit();
                      }}
                      aria-label="Product photos"
                      sx={{
                        position: 'absolute',
                        bottom: 4,
                        right: 4,
                        zIndex: 2,
                        padding: '4px',
                        backgroundColor: 'white',
                        color: 'primary.main',
                        borderRadius: '4px',
                        boxShadow: 1,
                        '&:hover': { backgroundColor: 'rgba(255,255,255,0.95)' },
                      }}
                  >
                    <AccountBoxIcon sx={{ fontSize: 22 }}/>
                  </IconButton>
              )}
          </HoverBox>
          
          <FlexBetween onClick={editProduct} mt={1}>
              <Box width="10%">
                  <ArrowRight fontSize="small" color="primary" />
              </Box>
              <Box width="90%">
                  <H2 fontSize={14} textAlign="left" ellipsis>
                      {getPrice(product, currency)}
                  </H2>
                  <H5 fontSize={12} textAlign="left" ellipsis color="text.secondary">
                      {product.name}
                  </H5>
              </Box>
          </FlexBetween>
      </Box>
  );
};

export default SellerProduct;
